export const CELL_SIZE = 270;

export const TAILLE_NOEUD_DEFAULT = {
  width: CELL_SIZE * 1.5,
  height: CELL_SIZE,
};

export const TAILLE_JALON_DEFAULT = {
  width: 60,
  height: CELL_SIZE * 10,
};
